"use strict";

/// event handlers for Fullstory
angular.module('PatientApp').run(['FullstoryService', 'VueEventTransmitter', '$log', '$window', '$cookieStore', function (FullstoryService, VueEventTransmitter, $log, $window, $cookieStore) {
  $window['_fs_ready'] = function () {
    if ($window.FS && $window.FS.getCurrentSessionURL) {
      var sessionUrlAtTime = $window.FS.getCurrentSessionURL(true);

      if (sessionUrlAtTime) {
        $cookieStore.put('FullStorySessionUrl', sessionUrlAtTime);
        $log.info('FullStorySessionUrl: ', sessionUrlAtTime);
      }
    } else {
      $log.error('Failed to get FullStory current session url');
    }
  };

  VueEventTransmitter.$on('user:changed', function (currentUser) {
    FullstoryService.identify(currentUser);
  });
}]);